import { useNode } from '@craftjs/core';
import React, { useCallback } from 'react';
import { Phone } from '@descope/page-editor-components';
import { EditorPhoneSettings } from './EditorPhoneSettings';

type Props = React.ComponentProps<typeof Phone>;

const EditorPhone = (props: Props) => {
	const {
		connectors: { connect, drag }
	} = useNode();

	const refCb = useCallback(
		(ref: HTMLDivElement) => connect(drag(ref)),
		[connect, drag]
	);

	return (
		<Phone
			ref={refCb}
			{...props}
			// we are setting the input to read only value so it won't pop validations error message when editing the page
			// on the generated page the input element will not be read only
			readOnly
			// we are setting the autoDetect to true because we don't want to show selected country code in the editor
			autoDetect
		/>
	);
};

EditorPhone.craft = {
	name: 'Phone Input',
	props: {
		name: 'phone',
		type: 'tel',
		placeholder: 'Phone',
		label: 'Phone',
		size: 'md',
		fullWidth: true,
		autoDetect: true,
		autoComplete: null as any // we cannot use undefined because we getting the uncontrolled to controlled warning, and empty string is adding the attribute to the dom
	},
	related: {
		settings: EditorPhoneSettings
	}
};

export { EditorPhone };
